import { OrderStatus } from 'src/types';
import { capitalizeFirstLetter } from 'src/utils';

export class OrderStatusUtils {
  public static getOrderStatusName(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.Draft:
        return 'Draft';
      case OrderStatus.LabProcessing:
        return 'Slide Image Needed';
      case OrderStatus.AiProcessing:
        return 'AI Processing';
      case OrderStatus.AiError:
        return 'AI Error';
      case OrderStatus.ReportPending:
        return 'Report Pending';
      case OrderStatus.ReportReady:
        return 'Report Ready';
      case OrderStatus.ReportRejected:
        return 'Report Rejected';
      case OrderStatus.Canceled:
        return 'Canceled';
      case OrderStatus.Deleted:
        return 'Deleted';
      default:
        return capitalizeFirstLetter(status);
    }
  }
}
